import { useEffect, useState } from 'react'
import './IconPicker.scss'
import Modal from './Modal'
import allAvailableIcons from './IconPicker/availableIcons'


interface Props {
    icon: string
    color: string
    update: (value: {
        icon: string
        color: string
    }) => void
}

const IconPicker = (props: Props) => {
    const {color: initialColor, icon: initialIcon, update} = props
    const [icon, setIcon] = useState(initialIcon)
    const [color, setColor] = useState(initialColor)
    const [showPicker, setShowPicker] = useState(false)
    const [filter, setFilter] = useState('')
    const [availableIcons, setAvailableIcons] = useState(allAvailableIcons)

    useEffect(() => {
        setIcon(initialIcon)
    }, [initialIcon])

    useEffect(() => {
        setColor(initialColor)
    }, [initialColor])

    const availableColors = [
    '#BED6C2',
    '#F1B364',
    '#EEBAAC',
    '#F0DBA4',
    '#CC8D42',
    '#C1CBBD',
    '#EF9B8B',
    '#F5CEB8',
    '#759A88',
    '#E9C070',
    '#FBEBA3',
    '#ECC0B8',
    '#A0714D',
    '#D2CA91',
    '#EE8D62',
    '#D7D688',
    '#D7D688',
    '#86A975',
    '#C8D8C0',
    '#A8A361',
    '#F7DD60',
    '#E5A446',
    '#6C7E79',
    '#E48C9C',
    '#74795E',
    '#CBD1DA',
    '#EDC55E',
    '#F7D7BB',
    '#CDB65B',
    '#E78472'
    ]

    //     '',
    //     '#8238C0',
    //     '#C842B5',
    //     '#CF4D6E',
    //     '#DCD564',
    //     '#A4E270',
    //     '#7DE78C',
    //     '#8AEBD2',
    //     '#98D2F0',
    //     '#A6AAF3',
    //     '#E64DFE',
    //     '#45D4B0',
    //     '#8185CA',
    // ]
    
    useEffect(() => {
        setAvailableIcons(allAvailableIcons.filter(icon => icon.includes(filter)))
    }, [filter])

    return <div className='icon-picker'>
        <div
            className={`picked-icon fa-solid fa-${icon}`}
            onClick={() => setShowPicker(true)}
            style={{color}}/>
        {showPicker && <Modal onCancel={() => {
            setShowPicker(false)
            update({
                color,
                icon
            })
        }}>
            <input value={filter} onChange={(e) => {setFilter(e.target.value)}} />

            <div className='available-icons'>
            { availableIcons.map((availableIcon) => 
                <div
                    className={`available-icon fa-solid fa-${availableIcon} ${icon === availableIcon ? 'selected' : ''}`}
                    key={availableIcon}
                    onClick={() => setIcon(availableIcon) }
                    style={{color: icon === availableIcon ? color : "#666"}}/>
            )}
            </div>

            <div className='available-colors'>
            { availableColors.map((availableColor) => 
                <div
                    className={`available-color ${color === availableColor ? 'selected' : ''}`}
                    key={availableColor}
                    onClick={() => setColor(availableColor) }
                    style={{backgroundColor: availableColor}}/>
            )}
            </div>
        </Modal>}
    </div>
}

export default IconPicker